import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IAuthResponse, IForgotPasswordDTO, ILoginDTO, IResetPasswordDTO } from '@/models/auth.model';
import { AUTH_SLICE_NAME } from './models';

export const logIn = createAsyncThunk<IAuthResponse, ILoginDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/login`,
  async (data: ILoginDTO) => {
    const response = await AuthAPI.login(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const forgotPassword = createAsyncThunk<unknown, IForgotPasswordDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/forgotPassword`,
  async (data: IForgotPasswordDTO) => {
    const response = await AuthAPI.forgotPassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const resetPassword = createAsyncThunk<unknown, IResetPasswordDTO, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/resetPassword`,
  async (data: IResetPasswordDTO) => {
    const response = await AuthAPI.resetPassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const logout = createAsyncThunk<unknown, void, { serializedErrorType: IApiError }>(
  `${AUTH_SLICE_NAME}/logout`,
  async () => {
    await AuthAPI.logout();
  },
  { serializeError: formatApiError },
);
